import fetch from 'cross-fetch';
import { fromJCAMP } from 'nmr-parser';
import { formatSpectra } from '../utilities/formatSpectra';
import generateID from '../utilities/generateID';
export async function readJcamp(file, options = {}) {
    const text = await file.text();
    return processJcamp(text, { name: file.name, ...options });
}
export function readJcampFromURL(jcampURL, options = {}) {
    return fetch(jcampURL)
        .then((response) => response.text())
        .then((jcamp) => processJcamp(jcamp, {
        ...{ source: { jcampURL } },
        ...options,
    }));
}
export function processJcamp(text, options = {}) {
    let output = { spectra: [], molecules: [] };
    let entries = fromJCAMP(text, {
        ...{
            noContour: true,
            xy: true,
            keepRecordsRegExp: /.*/,
            profiling: true,
        },
        ...options,
    });
    const { source = { file: { extension: 'jdx', binary: text } } } = options;
    for (const entry of entries) {
        const { dependentVariables, info, meta } = entry;
        const { name = info.title || `jcamp_${generateID()}` } = options;
        output.spectra.push({
            dependentVariables,
            meta,
            info,
            source,
            display: { name },
        });
    }
    return formatSpectra(output);
}
//# sourceMappingURL=readJcamp.js.map